import React from 'react';

export const MainTitle = () => {
  return (
    <div className="page-main-title">
      <div className="text">
        <p>ПРОФЕСІЙНА ЮРИДИЧНА ДОПОМОГА</p>
      </div>
      <div className="design-title-block">
        <div className="design3"></div>
        <div className="design2"></div>
        <div className="design1"></div>
      </div>
    </div>
  );
};
